import awsconfig from '@/amplifyconfiguration.json';
import { Amplify } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { ExaminationMenuType } from '../types/ExaminationMenuType';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { executeGet } from '@/client/rest';

Amplify.configure(awsconfig);

export const useExaminationMenu = (facilityId: string) => {
  const [examinationMenuList, setExaminationMenuList] = useState<ExaminationMenuType[]>([]);
  const [vipMenu, setVipMenu] = useState<ExaminationMenuType[]>([]);
  const [exoMenu, setExoMenu] = useState<ExaminationMenuType[]>([]);
  const [backdropOpen, setBackdropOpen] = useState<boolean>(true);

  const init = async () => {
    const attr = await fetchUserAttributes();
    const outPatientMenus = (await executeGet({
      apiName: 'medirecoWebApi',
      path: '/get-outpatient-list',
      options: {
        queryParams: {
          facilityId: facilityId,
          cognitoId: attr.sub!,
          vipFlag: `0`
        }
      }
    })) as any;

    const vipMenus = (await executeGet({
      apiName: 'medirecoWebApi',
      path: '/new-get-outpatient-list',
      options: {
        queryParams: {
          facilityId: facilityId,
          vipFlag: `1`,
          exoFlag: `0`
        }
      }
    })) as any;

    const exoMenus = (await executeGet({
      apiName: 'medirecoWebApi',
      path: '/new-get-outpatient-list',
      options: {
        queryParams: {
          facilityId: facilityId,
          vipFlag: `0`,
          exoFlag: `1`
        }
      }
    })) as any;

    setExaminationMenuList(outPatientMenus as ExaminationMenuType[]);
    setVipMenu(vipMenus.outpatients as ExaminationMenuType[]);
    setExoMenu(exoMenus.outpatients as ExaminationMenuType[]);
    setBackdropOpen(false);
  };

  useEffect(() => {
    init();
  }, []);

  return {
    examinationMenuList,
    exoMenu,
    vipMenu,
    backdropOpen
  };
};
